// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mv-0";
export var animationContainer = "_mv-1";
export var itemPrice = "_mv-a";
export var itemizedContent = "_mv-9";
export var itemizedHeader = "_mv-7";
export var itemizedRow = "_mv-8";
export var itemizedSection = "_mv-6";
export var modalContent = "_mv-2";
export var orderName = "_mv-3";
export var refundOption = "_mv-4";
export var refundOptionsContainer = "_mv-5";
export var shippingLabel = "_mv-b";
export var totalRow = "_mv-c";